/*
  ppz-meta.js — quello che il pixel Meta da solo non puo' sapere.   (v4, 19/10/2026)
  v4: porta il consenso WhatsApp/SMS (ppz_sms_consent) negli attributi del
      carrello, come fbc e fbp: il ponte lo legge dall'ordine e aggiorna il
      cliente su Shopify.
  v3: i cookie con lo stesso nome ripetuto (due `_fbc`) non danno piu' vuoto.

  Il pixel («Meta PurePet», Admin -> Impostazioni -> Eventi cliente) gira in una
  sandbox: non vede la pagina e non sa ne' che prezzo il cliente ha davanti ne'
  se ha scelto l'abbonamento. Questo file glielo dice:

  0. 'ppz_tema' — «ci sono». Se il pixel non lo riceve (file tolto o tornato
     alla versione vecchia) usa subito gli eventi di Shopify, come prima.

  1. fbc e fbp DENTRO L'ORDINE. `_fbc` (il clic sull'inserzione) e `_fbp` vanno
     negli attributi del carrello: l'ordine se li porta dentro e il ponte li
     rimanda a Meta con l'acquisto, anche quando Safari ha gia' cancellato i
     cookie. Fino al 02/10 si scrivevano una volta sola all'apertura della
     pagina: alla prima visita `_fbp` non c'era ancora (lo crea lo script di Meta
     un attimo dopo) e non veniva scritto piu'. Mancava in 14 ordini su 40.
     Ora si confrontano col carrello vero e si riscrivono quando servono, ma
     SOLO su un carrello che ha gia' qualcosa dentro: scrivere su un carrello
     che non esiste lo crea, e se nello stesso istante il cliente aggiunge un
     prodotto i carrelli diventano due e il prodotto puo' sparire.

  2. 'ppz_vista_prodotto' — la confezione che il cliente vede selezionata, con
     il prezzo che vede (abbonamento o singolo) e il tipo. Vale per le schede
     prodotto e per le landing. Il pixel ne fa il ViewContent.

  3. 'ppz_carrello' — dopo ogni modifica del carrello si rilegge /cart.js e si
     confronta con quello di prima: cosa e' entrato davvero, a che prezzo
     (sconti e abbonamento compresi), e di quanto e' salito il prezzo dei
     prodotti aggiunti. Il pixel ne fa l'AddToCart. Prima il valore era il
     prezzo di listino della variante: un abbonamento da 24,90 partiva come
     29,90.
     Si conta PRODOTTO PER PRODOTTO: un prodotto e' AGGIUNTO solo se ne ha piu'
     PEZZI di prima (ricariche, diffusori), non se sale il totale: il carrello
     rimette insieme le confezioni e con i prezzi delle ricariche 3 pezzi
     (2+1) costano 54,80 e 4 pezzi (una da 4) 39,90. Quindi il «meno» da 4 a 3
     fa SALIRE il totale (e non e' un'aggiunta) e il «piu'» da 3 a 4 lo fa
     SCENDERE (ed e' un'aggiunta, di valore 0: costa meno di prima).
     OGNI giro di modifiche manda il suo conto. Se il «prima» non c'e' (il
     carrello non si e' potuto leggere) manda senzaConfronto e il pixel usa
     l'evento di Shopify. Se il cliente cambia pagina prima del conto, il
     «prima» passa alla pagina dopo (sessionStorage) e il conto lo fa lei.

  SE CAMBI I NOMI DEGLI EVENTI ('ppz_tema', 'ppz_vista_prodotto',
  'ppz_carrello') VANNO CAMBIATI ANCHE NEL PIXEL.

  Non tocca il carrello ne' le sezioni: legge, e scrive solo i due attributi.
  Se qualcosa non va, non fa niente e non rompe niente.
*/
(function () {
  'use strict';

  if (window.ppzMeta) return;
  window.ppzMeta = 2;
  if (!window.fetch || !window.Promise) return;

  function pubblica(nome, dati) {
    try {
      var a = window.Shopify && window.Shopify.analytics;
      if (a && typeof a.publish === 'function') a.publish(nome, dati);
    } catch (e) { /* il pixel usera' il suo ripiego */ }
  }

  /* 0. Per primo, prima di qualsiasi altra cosa. */
  pubblica('ppz_tema', { versione: 2 });

  /* La fetch originale: le nostre letture passano di qui, cosi' non vengono
     scambiate per modifiche del carrello. */
  var fetchVero = window.fetch.bind(window);

  /* Le chiamate che CAMBIANO il carrello. /cart.js e /cart (sola lettura) no. */
  var MODIFICA = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|#|$)/;

  /* Quanto aspettare dopo l'ultima modifica prima di rileggere il carrello.
     Il conto parte anche prima, appena il cassetto smette di lavorare (vedi
     `osservaCassetto`): questa e' la rete di sicurezza. */
  var QUIETE = 400;

  function valuta() {
    try { return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'; }
    catch (e) { return 'EUR'; }
  }

  /* Lo stesso nome puo' esserci DUE volte: `_fbc` sul dominio (script di Meta)
     e `_fbc` senza dominio (pixel fino alla v11). Fino alla v2 in quel caso si
     tornava '' e l'ordine restava senza clic se il carrello si riempiva da una
     pagina senza fbclid (banco del 09/10/2026). Ora: per `_fbc`/`_fbp` vince il
     piu' recente (l'ora in millisecondi e' il terzo pezzo: fb.1.<ora>.<id>),
     per gli altri il primo. */
  function cookie(nome) {
    var trovati = [];
    String(document.cookie || '').split(';').forEach(function (p) {
      var s = p.replace(/^\s+/, '');
      var i = s.indexOf('=');
      if (i > 0 && s.slice(0, i) === nome) trovati.push(s.slice(i + 1));
    });
    if (!trovati.length) return '';
    if (trovati.length === 1 || !/^_fb[cp]$/.test(nome)) return trovati[0] || '';
    return trovati.reduce(function (a, b) {
      return (Number(String(b).split('.')[2]) || 0) > (Number(String(a).split('.')[2]) || 0) ? b : a;
    });
  }

  /* «€24,90», «24,90 €», «€1.234,56», «€25» -> centesimi interi. */
  function centesimi(testo) {
    var t = String(testo || '').replace(/[^\d.,]/g, '');
    if (!t) return NaN;
    var m = t.match(/^(.*?)[.,](\d{2})$/);
    if (m) return parseInt(m[1].replace(/[.,]/g, '') || '0', 10) * 100 + parseInt(m[2], 10);
    return parseInt(t.replace(/[.,]/g, ''), 10) * 100;
  }

  /* ======================================================================
     2. ppz_vista_prodotto: cosa vede il cliente
     ====================================================================== */

  /* Il nome del prodotto senza la confezione: Shopify scrive le varianti come
     «Ricariche per Gatti - 2 Ricariche». */
  function nomeProdotto(idVariante) {
    try {
      var varianti = window.ShopifyAnalytics.meta.product.variants || [];
      for (var i = 0; i < varianti.length; i++) {
        var v = varianti[i];
        var coda = v.public_title ? ' - ' + v.public_title : '';
        var nome = String(v.name || '');
        if (String(v.id) === idVariante || i === varianti.length - 1) {
          return coda && nome.slice(-coda.length) === coda ? nome.slice(0, -coda.length) : nome;
        }
      }
    } catch (e) { /* senza nome si manda lo stesso */ }
    return '';
  }

  /* Scheda prodotto (ppz-buybox.js): la confezione premuta e il tipo scelto,
     con le stesse regole con cui il modulo manda il piano al carrello. */
  function vistaScheda(radice) {
    var confezioni = radice.querySelectorAll('[data-ppz-bundle]');
    var scelta = radice.querySelector('[data-ppz-bundle][aria-pressed="true"]') || confezioni[0];
    if (!scelta) return null;
    var radio = radice.querySelector('input[name="ppz_purchase"]:checked');
    var piano = scelta.getAttribute('data-plan-id') || '';
    var abbonamento = !!(radio && radio.value === 'sub' && piano);
    var variante = String(scelta.getAttribute('data-variant-id') || '');
    return {
      pagina: 'scheda',
      variante: variante,
      prodotto: nomeProdotto(variante),
      pezzi: parseInt(scelta.getAttribute('data-units'), 10) || 1,
      centesimi: centesimi(scelta.getAttribute(abbonamento ? 'data-sub-price' : 'data-price')),
      tipo: abbonamento ? 'abbonamento' : 'singolo',
      piano: abbonamento ? String(piano) : ''
    };
  }

  /* Landing (ppz-offer.js): tre carte, ognuna col suo pulsante. Si prende la
     carta in evidenza (la «grande»), che e' quella su cui la pagina spinge,
     altrimenti la prima. Il tipo viene dall'interruttore. */
  function vistaLanding(radice) {
    var carta = radice.querySelector('[data-ppz-card].ppz-advo__card--big') || radice.querySelector('[data-ppz-card]');
    if (!carta) return null;
    var campo = carta.querySelector('form [name="id"]');
    var interruttore = radice.querySelector('[data-ppz-offer-tick]');
    var piano = carta.getAttribute('data-plan-id') || '';
    var abbonamento = !!(interruttore && interruttore.checked && piano);
    var offerta = window.ppzVistaOfferta || {};
    return {
      pagina: 'landing',
      variante: String((campo && campo.value) || ''),
      prodotto: String(offerta.prodotto || ''),
      pezzi: 0,
      centesimi: centesimi(carta.getAttribute(abbonamento ? 'data-sub-total' : 'data-once-total')),
      tipo: abbonamento ? 'abbonamento' : 'singolo',
      piano: abbonamento ? String(piano) : ''
    };
  }

  var vistaMandata = false;

  function mandaVista() {
    if (vistaMandata) return;
    var dati = null;
    try {
      var scheda = document.querySelector('[data-ppz-buy]');
      var landing = document.querySelector('[data-ppz-offer]');
      if (scheda) dati = vistaScheda(scheda);
      else if (landing) dati = vistaLanding(landing);
    } catch (e) { dati = null; }
    /* Dato incompleto = niente: il pixel usa il ripiego di Shopify, che e'
       meno preciso ma mai inventato. */
    if (!dati || !/^\d+$/.test(dati.variante) || !(dati.centesimi > 0)) return;
    vistaMandata = true;
    dati.valuta = valuta();
    pubblica('ppz_vista_prodotto', dati);
  }

  /* ======================================================================
     3. ppz_carrello: cosa e' entrato davvero nel carrello
     ====================================================================== */

  /* Quanti pezzi fa una confezione: «2 Ricariche» -> 2, «3 Diffusori» -> 3.
     Se il nome non comincia con un numero, la confezione vale 1. */
  function pezziConfezione(item) {
    var n = parseInt(String(item.variant_title || ''), 10);
    return n > 0 && n < 100 ? n : 1;
  }

  /* Il carrello ridotto a quello che serve:
     - righe: per ogni variante+piano quante confezioni e quanto costano
       DAVVERO (final_line_price = dopo gli sconti);
     - prodotti: per ogni prodotto quanti pezzi in tutto e quanto costa. */
  function riassumi(c) {
    var righe = {};
    var prodotti = {};
    (c.items || []).forEach(function (i) {
      /* I REGALI NON SONO UN'AGGIUNTA AL CARRELLO (06/10/2026). Guida e spray
         sono prodotti veri di tipo «Regalo», messi e tolti dal carrello da
         ppz-cart.js quando cambia la confezione. Qui non si contano: se no ogni
         regalo sarebbe un prodotto «aggiunto» in piu' (a valore zero) e Meta
         riceverebbe un AddToCart con dentro la guida. Il totale non cambia:
         costano zero. */
      if (i.product_type === 'Regalo') return;
      var alloc = i.selling_plan_allocation;
      var piano = alloc && alloc.selling_plan && alloc.selling_plan.id ? String(alloc.selling_plan.id) : '';
      var chiave = i.variant_id + '|' + piano;
      var prodotto = String(i.product_id || i.variant_id);
      var r = righe[chiave] || (righe[chiave] = {
        variante: String(i.variant_id), prodottoId: prodotto, piano: piano, prodotto: i.product_title || '', quantita: 0, centesimi: 0
      });
      r.quantita += i.quantity || 0;
      r.centesimi += i.final_line_price || 0;
      var p = prodotti[prodotto] || (prodotti[prodotto] = { pezzi: 0, centesimi: 0 });
      p.pezzi += (i.quantity || 0) * pezziConfezione(i);
      p.centesimi += i.final_line_price || 0;
    });
    return { totale: c.total_price || 0, valuta: c.currency || valuta(), righe: righe, prodotti: prodotti };
  }

  /* PRODOTTO PER PRODOTTO: un prodotto e' «aggiunto» solo se ne ha piu' pezzi
     di prima. Per quelli, le righe entrate (confezioni in piu') e di quanto e'
     salito il loro prezzo. Il cassetto, quando accorpa, puo' toccare anche
     altri prodotti: quelli non contano. */
  function confronta(prima, dopo) {
    var aggiunti = {};
    var centesimiAggiunti = 0;
    Object.keys(dopo.prodotti).forEach(function (id) {
      var d = dopo.prodotti[id];
      var p = prima.prodotti[id] || { pezzi: 0, centesimi: 0 };
      if (d.pezzi > p.pezzi) {
        aggiunti[id] = true;
        centesimiAggiunti += d.centesimi - p.centesimi;
      }
    });
    var aggiunte = [];
    Object.keys(dopo.righe).forEach(function (k) {
      var d = dopo.righe[k];
      if (!aggiunti[d.prodottoId]) return;
      var p = prima.righe[k];
      var piu = d.quantita - (p ? p.quantita : 0);
      if (piu > 0 && d.quantita > 0) {
        aggiunte.push({
          variante: d.variante,
          prodotto: d.prodotto,
          quantita: piu,
          centesimi: Math.round(d.centesimi / d.quantita),
          piano: d.piano
        });
      }
    });
    return {
      /* Le confezioni entrate, solo per i prodotti aggiunti. Vuoto = niente
         AddToCart (il «meno», il cestino, un cambio senza pezzi in piu'). */
      aggiunte: aggiunte,
      /* Di quanto e' salito il prezzo dei prodotti aggiunti: e' il valore vero
         dell'aggiunta, anche quando il carrello ha rimesso insieme le
         confezioni. Se e' sceso, 0. */
      centesimi: Math.max(0, centesimiAggiunti),
      tipo: aggiunte.some(function (a) { return a.piano; }) ? 'abbonamento' : 'singolo',
      totale: dopo.totale,
      valuta: dopo.valuta
    };
  }

  var fotografia = null;      /* il carrello dell'ultima lettura buona: il «prima» */
  var fotografiaInCorso = null;
  var pezziNelCarrello = 0;
  var inVolo = 0;             /* modifiche partite e non ancora finite */
  var giro = 0;               /* cresce a ogni modifica che parte */
  var aperto = false;         /* c'e' un giro di modifiche non ancora contato */
  var idGiro = '';
  var inizioGiro = 0;         /* quando e' partita la prima modifica del giro */
  var attesa = 0;
  var rinvii = 0;
  var tentativi = 0;
  var SOSPESO = 'ppz-meta-sospeso';
  var uscita = false;         /* la pagina se ne sta andando (pagehide) */
  var sospesoMio = '';        /* il giro lasciato in sospeso da QUESTA pagina */
  var ultimoMandato = null;   /* l'ultimo conto con aggiunte pubblicato qui */

  function sessione(chiave, valore) {
    try {
      if (valore === undefined) return window.sessionStorage.getItem(chiave);
      if (valore === null) window.sessionStorage.removeItem(chiave);
      else window.sessionStorage.setItem(chiave, valore);
    } catch (e) { /* navigazione privata: niente memoria tra le pagine */ }
    return null;
  }

  function leggiCarrello() {
    return fetchVero('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); });
  }

  function carrelloOccupato() {
    return !!document.querySelector('[data-ppz-cart][data-loading]');
  }

  function programma(ms) {
    window.clearTimeout(attesa);
    attesa = window.setTimeout(conta, ms === undefined ? QUIETE : ms);
  }

  /* Ogni giro chiuso manda il suo conto. Senza un «prima» buono (la lettura
     di partenza non c'e' stata) si dice al pixel che il conto non si puo'
     fare: lui allora manda subito l'aggiunta di Shopify. */
  function pubblicaConto(dopo) {
    /* Tornati indietro col browser (bfcache) su un giro lasciato in sospeso:
       se intanto l'ha contato un'altra pagina, qui non si conta piu'. */
    if (sospesoMio && !uscita) {
      var mio = sospesoMio;
      sospesoMio = '';
      var s = leggiSospeso();
      if (mio === idGiro && (!s || s.id !== idGiro)) return;
    }
    var conto = fotografia && dopo ? confronta(fotografia, dopo) : { aggiunte: [], senzaConfronto: true };
    /* Il pixel li usa per non contare due volte: 'dal' e 'alle' (inizio del
       giro e momento del conto) contro le aggiunte di Shopify, 'giro' come
       identificativo dell'evento (lo stesso giro su due pagine = un solo
       AddToCart per Meta) e nel cookie ppz_giro. */
    conto.dal = inizioGiro;
    conto.alle = Date.now();
    conto.giro = idGiro;
    pubblica('ppz_carrello', conto);
    var conAggiunte = conto.aggiunte.length > 0;
    ultimoMandato = conAggiunte ? { id: idGiro, dal: inizioGiro, conto: conto, quando: Date.now() } : null;
    /* Se la pagina se ne sta andando, il pixel potrebbe non fare in tempo: il
       conto fatto resta in sospeso e lo rimanda la pagina dopo (o il pixel
       nella cassa), a meno che il pixel abbia gia' scritto ppz_giro. */
    if (uscita && conAggiunte) sessione(SOSPESO, JSON.stringify(ultimoMandato));
    else sessione(SOSPESO, null);
  }

  function conta(subito) {
    if (!aperto || inVolo > 0) return;            /* ripartira' alla fine */
    /* Il cassetto sta ancora lavorando (ridisegno, accorpamento): si aspetta,
       ma non all'infinito. Uscendo dalla pagina non si aspetta piu'. */
    if (subito !== true && carrelloOccupato() && rinvii < 25) { rinvii++; programma(); return; }
    rinvii = 0;
    window.clearTimeout(attesa);
    var questo = giro;
    leggiCarrello().then(function (c) {
      /* Nel frattempo e' partita un'altra modifica: questa lettura potrebbe
         contarla a meta'. Si rifa' tutto alla fine di quella. */
      if (questo !== giro || !aperto) return;
      aperto = false;
      tentativi = 0;
      var dopo = riassumi(c);
      noteCarrello(c);
      pubblicaConto(dopo);
      fotografia = dopo;
      allineaAttributi();
    }).catch(function () {
      if (questo !== giro || !aperto) return;
      /* Lettura fallita: si riprova due volte, poi si chiude il giro senza
         conto (il pixel usa l'aggiunta di Shopify) e si riparte da capo. */
      if (++tentativi <= 2) { programma(1500); return; }
      tentativi = 0;
      aperto = false;
      fotografia = null;
      pubblicaConto(null);
      fotografa();
    });
  }

  /* `chiamata`: quando la pagina ha chiesto la modifica (prima dell'eventuale
     attesa della fotografia). E' l'orario che conta per il pixel: Shopify data
     la sua aggiunta da li'. */
  function inizio(chiamata) {
    if (!aperto) {
      aperto = true;
      idGiro = String(Date.now()) + '-' + Math.floor(Math.random() * 1e6);
      inizioGiro = chiamata || Date.now();
    }
    inVolo++;
    giro++;
    window.clearTimeout(attesa);
  }

  function fine() {
    inVolo = Math.max(0, inVolo - 1);
    if (inVolo === 0) programma();
  }

  function eModifica(indirizzo, metodo) {
    if (String(metodo || 'GET').toUpperCase() !== 'POST') return false;
    try {
      var u = new URL(String(indirizzo), window.location.href);
      return u.origin === window.location.origin && MODIFICA.test(u.pathname);
    } catch (e) { return false; }
  }

  /* Si osservano TUTTE le modifiche del carrello, da chiunque partano: il
     carrello del tema, i pulsanti delle landing, le app.
     Se la fotografia di partenza non e' ancora pronta, la modifica aspetta
     che lo sia (al massimo un secondo e mezzo): cosi' il «prima» e' sempre
     quello giusto. Succede solo se si clicca nel primo istante della pagina. */
  window.fetch = function (risorsa, opzioni) {
    var indirizzo = risorsa && typeof risorsa === 'object' && 'url' in risorsa ? risorsa.url : risorsa;
    var metodo = (opzioni && opzioni.method) || (risorsa && typeof risorsa === 'object' && risorsa.method) || 'GET';
    var modifica = false;
    try { modifica = eModifica(indirizzo, metodo); } catch (e) { modifica = false; }
    if (!modifica) return fetchVero.apply(window, arguments);

    var argomenti = arguments;
    var chiamata = Date.now();
    function parti() {
      inizio(chiamata);
      var risposta = fetchVero.apply(window, argomenti);
      risposta.then(fine, fine);
      return risposta;
    }
    if (!aperto && !fotografia && !fotografiaInCorso) fotografa();
    if (!aperto && fotografiaInCorso) {
      return Promise.race([
        fotografiaInCorso,
        new Promise(function (fatto) { window.setTimeout(fatto, 1500); })
      ]).then(parti);
    }
    return parti();
  };

  if (window.XMLHttpRequest) {
    var apri = XMLHttpRequest.prototype.open;
    var manda = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (metodo, indirizzo) {
      try { this.__ppzModifica = eModifica(indirizzo, metodo); } catch (e) { this.__ppzModifica = false; }
      return apri.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__ppzModifica) {
        inizio();
        var chiuso = false;
        this.addEventListener('loadend', function () { if (!chiuso) { chiuso = true; fine(); } });
      }
      return manda.apply(this, arguments);
    };
  }

  /* Il cassetto (ppz-cart.js) mette data-loading mentre lavora e lo toglie
     quando ha finito TUTTO, accorpamento compreso: e' il momento giusto per
     contare, senza aspettare oltre. */
  function osservaCassetto() {
    var cassetto = document.querySelector('[data-ppz-cart]');
    if (!cassetto || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (aperto && inVolo === 0 && !carrelloOccupato()) programma(60);
    }).observe(cassetto, { attributes: true, attributeFilter: ['data-loading'] });
  }

  /* Uscendo dalla pagina (cassa, un link, un modulo) con un conto in sospeso,
     lo si fa subito: la pagina resta viva il tempo di leggere il carrello. */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href], [name="checkout"], [data-ppz-cart-checkout]');
    if (a && aperto && inVolo === 0) conta(true);
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    var azione = (f && f.getAttribute && f.getAttribute('action')) || '';
    if (!/\/cart\/add/.test(azione) && aperto && inVolo === 0) conta(true);
  }, true);

  /* E se la pagina se ne va lo stesso prima del conto, il «prima» si porta
     alla pagina dopo, che fa il conto lei. Se il conto e' appena partito ma
     il pixel non ha ancora confermato (cookie ppz_giro), si porta il conto
     fatto: lo rimanda la pagina dopo, o il pixel nella cassa. */
  window.addEventListener('pagehide', function () {
    uscita = true;
    if ((aperto || inVolo > 0) && fotografia) {
      sospesoMio = idGiro;
      sessione(SOSPESO, JSON.stringify({ id: idGiro, dal: inizioGiro, prima: fotografia, quando: Date.now() }));
    } else if (ultimoMandato && cookie('ppz_giro') !== ultimoMandato.id && Date.now() - ultimoMandato.quando < 120000) {
      sessione(SOSPESO, JSON.stringify(ultimoMandato));
    }
  });

  function leggiSospeso() {
    try { return JSON.parse(sessione(SOSPESO) || 'null'); } catch (e) { return null; }
  }

  function contoSospeso() {
    var s = leggiSospeso();
    if (!s || !s.id || !(s.prima || s.conto)) return null;
    if (Date.now() - (s.quando || 0) > 120000 || cookie('ppz_giro') === s.id) { sessione(SOSPESO, null); return null; }
    return s;
  }

  /* La fotografia di partenza: e' il «prima» della prima aggiunta. Le
     modifiche aspettano che sia pronta (vedi window.fetch). */
  function fotografa() {
    var questo = giro;
    fotografiaInCorso = leggiCarrello().then(function (c) {
      noteCarrello(c);
      var ora = riassumi(c);
      var sospeso = contoSospeso();
      sessione(SOSPESO, null);
      /* Un conto gia' fatto dalla pagina prima: si ripubblica tale e quale
         (il pixel non lo manda due volte, vedi ppz_giro). */
      if (sospeso && sospeso.conto) {
        pubblica('ppz_carrello', sospeso.conto);
        sospeso = null;
      }
      if (questo !== giro || aperto) {
        /* Nel frattempo e' partita una modifica: il conto rimasto in sospeso
           dalla pagina prima confluisce nel suo (stesso «prima»). */
        if (sospeso && !fotografia) fotografia = sospeso.prima;
        return;
      }
      if (sospeso) {
        idGiro = sospeso.id;
        inizioGiro = sospeso.dal || 0;
        fotografia = sospeso.prima;
        pubblicaConto(ora);
      }
      fotografia = ora;
      allineaAttributi();
    }).catch(function () {
      /* Niente fotografia: meglio nessun «prima» che uno vecchio. Alla
         prossima modifica si riprova. */
      if (questo === giro && !aperto) fotografia = null;
    }).then(function () { fotografiaInCorso = null; });
  }

  /* Il carrello puo' essere cambiato in un'altra scheda: tornando su questa
     (o tornando indietro col browser) si rifotografa, se non c'e' un conto in
     sospeso. Le modifiche intanto aspettano la fotografia nuova. */
  function rifotografa() {
    if (aperto || inVolo > 0 || fotografiaInCorso) return;
    fotografa();
  }

  /* ======================================================================
     1. fbc e fbp negli attributi del carrello
     ====================================================================== */

  /* Se il pixel non ha ancora scritto `_fbc` ma nell'indirizzo c'e' il `fbclid`,
     lo si costruisce qui nel formato che vuole Meta: fb.1.<millisecondi>.<id>.
     Il millisecondo si fissa alla prima lettura: cosi' la stessa visita non
     riscrive l'attributo a ogni controllo. */
  var fbcDaIndirizzo = '';
  try {
    var clic = new URLSearchParams(window.location.search).get('fbclid') || '';
    if (clic) fbcDaIndirizzo = 'fb.1.' + Date.now() + '.' + clic;
  } catch (e) { /* indirizzo illeggibile: resta il cookie */ }

  function clicDi(fbc) {
    return String(fbc || '').split('.').slice(3).join('.');
  }

  /* Il clic nell'indirizzo e' il piu' recente: vince su un cookie di un clic
     vecchio. Altrimenti il cookie. */
  function ricavaFbc() {
    var c = cookie('_fbc');
    if (fbcDaIndirizzo && clicDi(c) !== clicDi(fbcDaIndirizzo)) return fbcDaIndirizzo;
    return c || fbcDaIndirizzo;
  }

  var attributiNelCarrello = null;   /* quelli letti dall'ultimo /cart.js */
  var scrivendo = false;

  function noteCarrello(c) {
    attributiNelCarrello = (c && c.attributes) || {};
    pezziNelCarrello = (c && c.item_count) || 0;
  }

  function allineaAttributi() {
    /* Solo su un carrello che esiste gia' (ha qualcosa dentro) e quando
       nessuno lo sta modificando: vedi il punto 1 in testa. */
    if (scrivendo || !attributiNelCarrello || pezziNelCarrello <= 0 || aperto || inVolo > 0) return;
    var fbc = ricavaFbc();
    var fbp = cookie('_fbp');
    var nuovi = {};
    if (fbc && attributiNelCarrello.ppz_fbc !== fbc && clicDi(attributiNelCarrello.ppz_fbc) !== clicDi(fbc)) nuovi.ppz_fbc = fbc;
    if (fbp && attributiNelCarrello.ppz_fbp !== fbp) nuovi.ppz_fbp = fbp;

    /* Consenso WhatsApp/SMS: dal localStorage (scritto dal cookie helper) agli
       attributi del carrello, cosi' finisce nell'ordine e il ponte lo legge. */
    try {
      var consenso = JSON.parse(localStorage.getItem('ppz_sms_consent') || 'null');
      if (consenso && consenso.ts && !attributiNelCarrello.ppz_sms_consent) {
        nuovi.ppz_sms_consent = '1';
        nuovi.ppz_sms_consent_ts = consenso.ts;
      }
    } catch (e) { /* localStorage non leggibile: si riprova dopo */ }

    if (!Object.keys(nuovi).length) return;

    scrivendo = true;
    fetchVero('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: nuovi })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c && c.attributes) noteCarrello(c); })
      .catch(function () { /* si riprova al prossimo controllo */ })
      .then(function () { scrivendo = false; });
  }

  /* `_fbp` lo crea lo script di Meta qualche istante DOPO l'apertura della
     pagina: si ricontrolla ogni secondo e mezzo per i primi 15 secondi. */
  var controlliFbp = 0;
  var giroFbp = window.setInterval(function () {
    controlliFbp++;
    allineaAttributi();
    if (controlliFbp >= 10) window.clearInterval(giroFbp);
  }, 1500);

  /* ======================================================================
     Partenza
     ====================================================================== */

  /* Questo file e' caricato con defer: quando gira la pagina e' gia' tutta
     letta, quindi la confezione selezionata si legge subito. */
  mandaVista();
  fotografa();

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') rifotografa();
  });
  window.addEventListener('pageshow', function (e) {
    uscita = false;   /* tornati indietro col browser: la pagina e' di nuovo viva */
    if (e.persisted) rifotografa();
  });

  function pronta() {
    mandaVista();   /* se la pagina non era ancora pronta prima */
    osservaCassetto();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pronta);
  } else {
    pronta();
  }
})();

